//const apiBaseUrl = 'http://localhost:8081/';
const apiBaseUrl = 'https://api2.strivere.com:8081/';
const apiArcEmailBaseUrl = `${apiBaseUrl}arc-email/`;

export const apiUploadCsvUrl = `${apiBaseUrl}upload_csv/`;
export const apiListedClosedUrl = `${apiBaseUrl}listed-closed-properties-service/`;
export const apiBuyerStatusUrl = `${apiArcEmailBaseUrl}buyer-status/`;
export const apiNegUCUrl = `${apiArcEmailBaseUrl}financing-email/`;
export const apiPriceChangeUrl = `${apiArcEmailBaseUrl}list-price-change/`;
export const apiBackOnMarketUrl = `${apiArcEmailBaseUrl}back-on-the-market/`;
export const apiHscClosingUrl = `${apiArcEmailBaseUrl}hsc-closing/`;
export const apiReferralClosingUrl = `${apiArcEmailBaseUrl}referral-closing/`;
export const apiOffMarketSellerUrl = `${apiArcEmailBaseUrl}off-market/`;
